// Sampark ki ek hi jagah. Number badalna ho to sirf yahan badlo.
//
// WhatsApp number wahi hai jo ContactUs / product page pehle se use karte the.
// PHONE_DISPLAY jaan-boojh kar khaali hai — owner jo number website par dikhana
// chahe wahi yahan likhe (khaali ho to phone wali line dikhti hi nahi).

export const WHATSAPP_NUMBER: string = "919258294692";
export const PHONE_DISPLAY: string = "";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.chawlaispat&pcampaignid=web_share";

export const whatsappLink = (text?: string): string =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
